import styled from 'styled-components';

export default styled.div`
  .repertoire-container-breadcrumbs-right {
    height: 48px;
    background-color: #f3f4f9;
    display: flex;
    align-items: center;
    gap: 16px;
    border-radius: 18px;
    padding-left: 20px;
    padding-right: 4px;
    .repertoire-container-breadcrumbs-right-icon {
      display: flex;
      align-items: center;
      gap: 8px;
      .repertoire-container-breadcrumbs-right-icon-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #333333;
      }
    }
    .repertoire-container-breadcrumbs-right-select {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
    }
  }
  .repertoire-container {
    height: calc(100vh - 56px - 95px);
    position: relative;
    .repertoire-container-search-wrap {
      display: flex;
      flex-direction: column;
      /* grid-template-columns: 2fr 1fr 1fr 1fr 1fr; */
      gap: 8px;
      margin-bottom: 25px;
      .repertoire-container-search-wrap-one {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 12px;
      }
      .repertoire-container-search-wrap-two {
        display: grid;
        grid-template-columns: 2fr 2fr 2fr;
        gap: 12px;
        .repertoire-container-search-wrap-two-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
      }
      .repertoire-container-search-wrap-three {
        display: grid;
        grid-template-columns: 2fr 2fr 2fr;
        gap: 12px;
        .repertoire-container-search-wrap-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
      }
      .repertoire-container-search-wrap-button {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .repertoire-container-content {
      height: calc(100vh - 80px - 68px - 86px - 25px - 50px);
    }
    .repertoire-container-footer {
      position: absolute;
      bottom: 0;
      left: -24px;
      right: -24px;
      height: 68px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 24px;
      padding-left: 24px;
      .repertoire-container-footer-button-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        .repertoire-container-footer-text {
          font-weight: 400;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0px;
          color: #ffa929;
          margin-right: 24px;
        }
      }
    }
  }
  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    padding-right: 24px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .operation-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    .operation-wrap-item {
      cursor: pointer !important;
      color: #2c9ae9;
    }
    .operation-wrap-item-disabled {
      color: #999999;
      cursor: not-allowed !important;
    }
  }
  .order-drawer-content {
    padding: 24px;
    .order-drawer-content-title {
      width: 1152px;
      height: 34px;
      display: flex;
      align-items: center;
      margin: 0 auto;
      .order-drawer-content-title-text {
        font-weight: 500;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0px;
        color: #1c1f23;
        margin-right: 24px;
        margin-left: 8px;
      }
      .order-drawer-content-title-text-tip {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: 0px;
        color: #ffa929;
      }
    }
    .order-drawer-content-check-wrap {
      width: 1152px;
      margin: 0 auto;
      height: 100%;
      padding: 12px 20px;
      background-color: #f3f4f9;
      border-radius: 4px;
      .return-reason-title {
        font-weight: 500;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #333333;
        margin-bottom: 16px;
      }
    }
    .return-reason-textarea-wrap {
      width: 1152px;
      margin: 24px auto 0;
      .return-reason-textarea-wrap-title {
        font-weight: 400;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;

        height: 30px;
        color: #333333;
      }
    }
    .return-reason-button-wrap {
      width: 1152px;
      margin: 24px auto 0;
      display: flex;
      justify-content: center;
      gap: 24px;
    }
  }
`;
